import { useState, useEffect, useContext, useRef } from "react";
import moment from "moment";
//Tabs components
import TransferenciaTab from "./ModalReceberTabs/TransferenciaTab";
import DinheiroTab from "./ModalReceberTabs/DinheiroTab";
//MUI
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
//icons
import PaidIcon from "@mui/icons-material/Paid"; //cabecalho
import CreditCardIcon from "@mui/icons-material/CreditCard"; //Credit card
import LocalAtmIcon from "@mui/icons-material/LocalAtm"; //Nota
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth"; //Calendar
import AccountBalanceIcon from "@mui/icons-material/AccountBalance"; //Banco
import RequestPageIcon from "@mui/icons-material/RequestPage";

import { AuthContext } from "../../../../../../shared/context/auth-context";
import { useHttpClient } from "../../../../../../shared/hooks/http-hook";

import "./ModalReceber.scss";
import toast from "react-hot-toast";
import CreditoTab from "./ModalReceberTabs/CreditoTab";
import ChequeTab from "./ModalReceberTabs/ChequeTab";
import { ClinicaContext } from "../../../../../../shared/context/clinica-context";
import { useLoading } from "../../../../../../shared/context/LoadingContext";

import InputText from "../../../../../../shared/components/inputs/InputText/InputText";
import { fixSpaces } from "../../../../../../shared/util/helperFunctions";

function ModalReceber({
  open,
  handleCloseModalReceber,
  nomeCliente,
  valorAPagar,
  idParcela,
  contaCorr,
  updateContaCorrente,
  descParcela,
  modoContingenciaAtivo,
}) {
  const { startLoading, stopLoading } = useLoading();
  const [openModal, setOpenModal] = useState(open);
  const [showTab, setShowTab] = useState();
  const [contaCorrente, setContaCorrente] = useState(contaCorr);
  const [conta, setConta] = useState();
  const [totalPorReceber, setTotalPorReceber] = useState();
  const { sendRequest } = useHttpClient();
  const [caixas, setCaixas] = useState();
  const [parcela, setParcela] = useState();
  const [descricao, setDescricao] = useState(
    descParcela || "Tratamento dentário",
  );

  const auth = useContext(AuthContext);
  const clinica = useContext(ClinicaContext);

  const checkboxRef = useRef(null);

  // A parcela tem uma FTE quando documentoEletronico é uma FTE bem-sucedida.
  const parcelaTemFTE =
    parcela?.documentoEletronico?.succeeded === true &&
    parcela?.documentoEletronico?.tipoDocumento === "FTE";

  useEffect(() => {
    setOpenModal(open);
    setContaCorrente(contaCorrente);

    let contaFiltrada;
    let parcelaFiltrada;

    contaCorr.contas.forEach((c) => {
      c.parcelas.forEach((p) => {
        if (p._id === idParcela) {
          parcelaFiltrada = p;
          contaFiltrada = c;
        }
      });
    });

    setParcela(parcelaFiltrada);
    setConta(contaFiltrada);

    if (contaFiltrada) {
      setTotalPorReceber(
        contaFiltrada.parcelas.reduce(
          (total, item) =>
            !item.parcelaPaga ? total + item.quantiaPorPagar : total,
          0,
        ),
      );
    }
  }, [open]);

  useEffect(() => {
    const fetchCaixas = async () => {
      startLoading();
      try {
        const responseData = await sendRequest(
          `${process.env.REACT_APP_BACKEND_LINK}/api/caixas/clinica/${clinica.clinica._id}`,
          "GET",
          null,
          {
            Authorization: "Bearer " + auth.token,
          },
        );
        setCaixas(
          responseData.caixas.map((cai) => {
            return { id: cai.id, value: cai.caixa };
          }),
        );
      } catch (err) {
        console.error("err", err);
      } finally {
        stopLoading();
      }
    };
    fetchCaixas();
  }, [sendRequest, clinica.clinica._id, auth.token]);

  const receberHandler = async (dados, emitirDocumento) => {
    startLoading();
    let emitindoDFE = false;

    try {
      // 1. Verificar se a parcela já foi paga (evita duplo-pagamento)
      const checkBody = {
        parcelaId: parcela._id,
        clinicaId: clinica.clinica._id,
      };

      const responseCheck = await sendRequest(
        `${process.env.REACT_APP_BACKEND_LINK}/api/contascorrentes/parcelas/verificarrecebimento`,
        "POST",
        JSON.stringify(checkBody),
        {
          Authorization: "Bearer " + auth.token,
          "Content-Type": "application/json",
        },
      );

      if (responseCheck.parcelaPaga) {
        toast.error(
          "A parcela que pretende receber já se encontra recebida. Por favor faça refresh da página.",
        );
        handleCloseModalReceber();
        stopLoading();
        return;
      }

      // 2. Construir payload simples
      const body = {
        contaCorrenteId: contaCorrente._id,
        contaId: conta._id,
        quantiaPaga: dados.quantiaPaga,
        metodoPagamento: dados.metodoPagamento,
        caixa: dados.caixa,
        dataPagamento: dados.dataPagamento,
        observacao: dados.observacao,
        oculto: checkboxRef.current?.checked || false,
        descricao: fixSpaces(descricao) || "Tratamento dentário",

        // Campos específicos por método
        ...(dados.banco && { banco: dados.banco }),
        ...(dados.dataCheque && { dataCheque: dados.dataCheque }),
        ...(dados.nrCheque && { nrCheque: dados.nrCheque }),
        ...(dados.nrContaCliente && { nrContaCliente: dados.nrContaCliente }),
        ...(dados.cartao && { cartao: dados.cartao }),

        utilizador: auth.userId,
        nomeCliente,
      };

      // 3. Chamar o endpoint único — backend faz toda a lógica complexa
      const response = await sendRequest(
        `${process.env.REACT_APP_BACKEND_LINK}/api/contascorrentes/parcelas/${parcela._id}/receber`,
        "POST",
        JSON.stringify(body),
        {
          Authorization: "Bearer " + auth.token,
          "Content-Type": "application/json",
        },
      );

      toast.success(
        `Pagamento efetuado com sucesso!${
          response.contaLiquidada ? " Conta Liquidada!" : ""
        }`,
      );

      // 4. Atualizar canDelete do plano de tratamento se necessário
      //    (só se for a primeira parcela paga desta conta)
      await atualizarCanDeletePlanoTratamento(response.contaCorrente);

      // 5. Se vai emitir FRE, passa info para o componente pai
      if (emitirDocumento === "emitirFRE") {
        emitindoDFE = true;
        updateContaCorrente(
          response.contaCorrente,
          {
            IdcontaCorrente: contaCorrente._id,
            Idconta: conta._id,
            IdParcela: parcela._id,
          },
          "FRE",
        );
      } else {
        updateContaCorrente(response.contaCorrente);
        handleCloseModalReceber();
      }
    } catch (err) {
      console.error("Erro ao receber parcela:", err);
      toast.error(err.message || "Erro ao receber parcela");
    } finally {
      // Quando vai emitir DFE, o spinner é gerido por emitirDocumentoFiscal no pai
      if (!emitindoDFE) stopLoading();
    }
  };

  // Helper para atualizar canDelete (mantém lógica original de "primeira parcela paga")
  const atualizarCanDeletePlanoTratamento = async (contaCorrenteAtualizada) => {
    // Encontrar a conta atualizada
    const contaAtualizada = contaCorrenteAtualizada.contas.find(
      (c) => c._id === conta._id,
    );
    if (!contaAtualizada) return;

    const nrParcelasPagas = contaAtualizada.parcelas.filter(
      (p) => p.quantiaPaga > 0,
    ).length;

    // Só executa se for exatamente a primeira parcela paga
    if (nrParcelasPagas !== 1) return;

    try {
      const planoTratamento = await sendRequest(
        `${process.env.REACT_APP_BACKEND_LINK}/api/planostratamento/orcamento/${contaAtualizada.orcamento._id}`,
        "GET",
        null,
        { Authorization: "Bearer " + auth.token },
      );

      const planoTratamentoFiltrado = planoTratamento.planosTratamento.find(
        (plano) => plano.ativo === true,
      );

      if (!planoTratamentoFiltrado) return;

      const formData = new FormData();
      formData.append("canDelete", false);
      await sendRequest(
        `${process.env.REACT_APP_BACKEND_LINK}/api/planostratamento/candelete/${planoTratamentoFiltrado._id}`,
        "PATCH",
        formData,
        { Authorization: "Bearer " + auth.token },
      );
    } catch (err) {
      console.error("Erro ao atualizar canDelete:", err);
      // Não bloqueia o fluxo principal — o pagamento já foi feito
    }
  };

  const descricaoChangeHandler = (value) => {
    setDescricao(value);
  };

  return (
    <>
      <Modal
        open={openModal}
        onClose={handleCloseModalReceber}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box
          className="fluxo-atendimento__modal__box aprovar-orcamento__modal"
          id="modal__cinquentaPorCento"
        >
          <h1 className="fluxo-atendimento__modal__titulo">
            Receber receita de {nomeCliente}
          </h1>

          <div className="modal-receber__cabecalho">
            <div className="modal-receber__cabecalho__data-divida">
              <div className="modal-receber__cabecalho__data">
                <CalendarMonthIcon className="modal-receber__cabecalho__icon" />{" "}
                {moment().format("DD-MM-YYYY")}
              </div>
              <div className="modal-receber__cabecalho__divida">
                <PaidIcon className="modal-receber__cabecalho__icon" />
                {valorAPagar}$00
              </div>
            </div>
            <span className="modal-receber__cabecalho__meio-pagamento">
              Meio de pagamento
            </span>

            {!showTab && (
              <div className="modal-receber__msgEscolhaMetodo">
                * Escolha o método de pagamento
              </div>
            )}
          </div>
          <div className="modal-receber__tabs">
            <div
              className={`modal-receber__tabs--tab ${
                showTab === "Dinheiro" && "modal-receber__tabs--tab--active"
              }`}
              onClick={() => setShowTab("Dinheiro")}
            >
              <LocalAtmIcon />
              Dinheiro
            </div>
            <div
              className={`modal-receber__tabs--tab ${
                showTab === "Credito" && "modal-receber__tabs--tab--active"
              }`}
              onClick={() => setShowTab("Credito")}
            >
              <CreditCardIcon />
              Crédito
            </div>
            <div
              className={`modal-receber__tabs--tab ${
                showTab === "Internet banking" &&
                "modal-receber__tabs--tab--active"
              }`}
              onClick={() => setShowTab("Internet banking")}
            >
              <AccountBalanceIcon />
              Transferência
            </div>
            <div
              className={`modal-receber__tabs--tab ${
                showTab === "Cheque" && "modal-receber__tabs--tab--active"
              }`}
              onClick={() => setShowTab("Cheque")}
            >
              <RequestPageIcon />
              Cheque
            </div>
          </div>

          {showTab && (
            <>
              <div className="checkboxOcultoContainer">
                <span>Ocultar</span> <input type="checkbox" ref={checkboxRef} />
              </div>

              <div style={{ marginTop: "20px" }}>
                <InputText
                  initialValue={descricao}
                  label="Descrição"
                  handleChange={descricaoChangeHandler}
                />
              </div>

              {showTab === "Dinheiro" && caixas && parcela && (
                <DinheiroTab
                  handleCloseModalReceber={handleCloseModalReceber}
                  valor={valorAPagar}
                  receberHandler={receberHandler}
                  totalPorReceber={totalPorReceber}
                  caixas={caixas}
                  cliente={contaCorrente.cliente}
                  modoContingenciaAtivo={modoContingenciaAtivo}
                  parcelaTemFTE={parcelaTemFTE}
                />
              )}

              {showTab === "Internet banking" && caixas && parcela && (
                <TransferenciaTab
                  handleCloseModalReceber={handleCloseModalReceber}
                  valor={valorAPagar}
                  receberHandler={receberHandler}
                  totalPorReceber={totalPorReceber}
                  caixas={caixas}
                  parcela={parcela}
                  cliente={contaCorrente.cliente}
                  modoContingenciaAtivo={modoContingenciaAtivo}
                  parcelaTemFTE={parcelaTemFTE}
                />
              )}

              {showTab === "Credito" && caixas && parcela && (
                <CreditoTab
                  valor={valorAPagar}
                  handleCloseModalReceber={handleCloseModalReceber}
                  receberHandler={receberHandler}
                  totalPorReceber={totalPorReceber}
                  caixas={caixas}
                  parcela={parcela}
                  cliente={contaCorrente.cliente}
                  modoContingenciaAtivo={modoContingenciaAtivo}
                  parcelaTemFTE={parcelaTemFTE}
                />
              )}

              {showTab === "Cheque" && caixas && parcela && (
                <ChequeTab
                  valor={valorAPagar}
                  handleCloseModalReceber={handleCloseModalReceber}
                  receberHandler={receberHandler}
                  totalPorReceber={totalPorReceber}
                  caixas={caixas}
                  parcela={parcela}
                  cliente={contaCorrente.cliente}
                  modoContingenciaAtivo={modoContingenciaAtivo}
                  parcelaTemFTE={parcelaTemFTE}
                />
              )}
            </>
          )}
        </Box>
      </Modal>
    </>
  );
}

export default ModalReceber;
